import React from "react";
import { ArrowRight } from "lucide-react";
import content from "@/data/content.json";
import { Label } from "./Primitives";
import { GoogleBadge } from "./GoogleBadge";
import { FlowLines } from "./FlowLines";

const { hero } = content;

export const Hero = () => (
  <section data-testid="hero" className="has-lines relative overflow-hidden bg-[#1e2532] text-white on-dark">
    <FlowLines />
    <div className="hero-pad mx-auto grid max-w-[1240px] grid-cols-1 items-center gap-9 px-6 md:px-10 lg:grid-cols-[1.12fr_0.88fr] lg:gap-12">
      <div>
        <Label testId="hero-label">{hero.label}</Label>

        <h1 className="mt-7 font-bold" data-testid="hero-h1">
          {hero.h1Lines.map((line, i) => (
            <span
              className="block whitespace-nowrap"
              key={line}
              style={{ color: i === hero.h1Lines.length - 1 ? "var(--accent)" : undefined }}
            >
              {line}{i < hero.h1Lines.length - 1 ? " " : ""}
            </span>
          ))}
        </h1>

        <p className="mt-6 max-w-[620px] text-[16.5px] leading-[1.72] text-white/72">{hero.subline}</p>

        <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4">
          <a
            href="#kontakt"
            data-testid="hero-primary-cta"
            className="btn-solid inline-flex items-center px-7 py-[15px] text-[13.5px] font-bold uppercase tracking-[0.06em]"
          >
            <span>{hero.primaryCta}</span>
          </a>
          <a
            href="#leistungen"
            data-testid="hero-secondary-cta"
            className="inline-flex items-center gap-2.5 text-[15px] font-semibold text-white/90"
          >
            <span className="link-underline">{hero.secondaryCta}</span>
            <ArrowRight size={17} />
          </a>
        </div>

        <div className="mt-7 flex flex-wrap items-center gap-5">
          <GoogleBadge rating={hero.google.rating} sub={hero.google.sub} />
          <p className="text-[13.5px] italic text-white/50" data-testid="hero-note">
            {hero.note}
          </p>
        </div>
      </div>

      <div className="img-frame media-hero hidden w-full lg:block">
        <img
          src={hero.image}
          alt={hero.imageAlt}
          width="1300"
          height="867"
          fetchPriority="high"
          decoding="async"
          className="h-full w-full"
        />
        <div className="pointer-events-none absolute inset-0 rounded-[6px] border border-white/10" />
      </div>
    </div>
  </section>
);
